import { FEED_NOT_SUPPORTED_LANGS } from '../config';

export default {
  methods: {
    isFeedSupportedForLang: (lang) => {
      return !FEED_NOT_SUPPORTED_LANGS.includes(lang);
    },
  },
};
